// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qt_a bhy_sw bhy_kx bhy_ky","PostDetailRight__brandDaysPosts":"qt_b bhy_sw bhy_kx bhy_ky"};